/**
 * Max size of uploaded file in bytes.
 */
export const MAX_FILE_SIZE = 10000000;
